// This is the default text of the application
// Australia is the default language
export default {
    message: {
        error: {
            default: 'Sorry, an error has occurred: Please refresh this page, or contact us by email.',
            short: 'Sorry, an error has occurred:'
        },
        contact: {
            companyNameExample: 'E.g ABC Pty Limited',
            companyNumberLabel: 'ABN/ACN (if applicable)',
            companyNumberLabelForIndividual: 'ABN (if applicable)',
            companyNumberPlaceholder: 'Enter the ABN or ACN that matches the Company name above',
            companyNumberPlaceholderForCompanyMobile: 'Enter the ABN or ACN',
            companyNumberPlaceholderForIndividual: 'Enter the ABN that matches the individual name above',
            companyNumberPlaceholderForIndividualMobile: 'Enter the ABN',
            stateRegionLabel: 'State/Region',
            ownerNamePlaceholderForCompany: 'Enter the full name of the Company including "Pty Limited"',
            ownerNamePlaceholderForCompanyMobile: 'Enter the full name of the company',
        },
        payment: {
            loading: 'We are loading the payment data',
        },
        price: {
            baseFee: 'Base fee',
            total: 'Total',
            tax: 'GST',
        },
        class: 'Class',
    }
};
